import React, { useEffect } from 'react'
import AppFrequencyHoursAutocomplete from '@components/Autocomplete/FrequencyHours'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData, useManualExecution } from 'Pages/ReportsAlerts/Reports/@signals'
import { array, object } from 'yup'


export default function ReportFrequencyHoursField() {

	const {
		frequencyHours,
		setFrequencyHoursInfo,
		error
	} = useReportFormInfo(reportFormData.peek()?.frequencyHours || [], "frequencyHours", object(!useManualExecution.value ? {
		frequencyHours: array()
			.required("Must provide at least one hour between 0 and 23")
			.min(1, "Must provide at least one hour between 0 and 23")
	} : {}))

	useEffect(() => {
		if (useManualExecution.value) setFrequencyHoursInfo([])
	}, [useManualExecution.value])

	return <AppFrequencyHoursAutocomplete
		disabled={useManualExecution.value}
		label="Execution frequency"
		placeholder="Select frequency hours"
		value={frequencyHours || []}
		onChange={e => setFrequencyHoursInfo(e.target.value)}
		error={error}
	/>
}